<template>
    <div class="flag-container text-center">
        <b-img src="/images/home-page/new-flag.svg" class="w-100"></b-img>
        <p class="flag-text text-white text-overline mb-0 w-100"><slot/></p>
    </div>
</template>

<script>
    export default {
        name: "NewFlag",
    }
</script>

<style scoped>
    .flag-text {
        position: absolute;
        right: 0;
        top: 17px;
        padding-left: 15px;
    }

    .flag-container {
        position: relative;
    }
</style>